import { Component } from '@angular/core';
import { User } from '../../../models/user.model';
import { UserService } from '../../../services/user.service';
import { ModalsService } from '../../../services/modals.service';
import { ConfirmModalComponent } from '../../../shared/components/confirm-modal/confirm-modal.component';
import { HttpParams } from '@angular/common/http';
import { UserSearchRequest } from '../user-search/user-search.component';
import { SortParam } from '../../../shared/components/sort-toggle/sort-toggle.component';
import { AbstractListComponent } from '../../../shared/components/abstract-list/abstract-list.component';
import { ActivatedRoute } from '@angular/router';
import { AuthUser } from '../../../models/auth-user.model';

@Component({
  selector: 'app-user-list',
  templateUrl: './user-list.component.html'
})
export class UserListComponent extends AbstractListComponent<User, UserSearchRequest> {

  currentUser: AuthUser;

  constructor(
    private userService: UserService,
    private route: ActivatedRoute,
    private modalService: ModalsService
  ) {
    super();
    this.sortParams = this.userService.defaultSort;
    this.route.data.subscribe(data => {
      this.listItems = data.userListResolverResponse;
    });
    this.userService.currentUser.subscribe(authUser => {
      this.currentUser = authUser;
    });
  }

  isAdmin(roles: string[]) {
    return roles.find(role => role === 'ROLE_admin');
  }

  isCurrentUser(user: User) {
    return user.id === this.currentUser.id;
  }

  deleteUser(userId, index) {
    const modalConfig = {
      title: 'USERS.REMOVE_MODAL.TITLE',
      message: 'USERS.REMOVE_MODAL.MESSAGE'
    };

    this.modalService.show(ConfirmModalComponent, null, null, 'modal-md', modalConfig).observable.subscribe(() => {
      this.userService.deleteUser(userId).subscribe(res => {
        this.onDeletePageItem();
      });
    });
  }

  protected getListItems(params: HttpParams) {
    this.userService.getUserList(params).subscribe(res => {
      this.listItems = res;
    });
  }

  toggleEnableUser(user: User, index: number) {
    this.userService.enableUser(user.id, {enabled: !user.enabled}).subscribe(res => {
      this.listItems.content[index].enabled = !user.enabled;
    });
  }

  sendSignupEmail(userId: number) {
    this.userService.sendSignupEmail(userId).subscribe();
  }
}
